import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const pub = axios.create({ baseURL: `${API}/public` });
export const mediaUrl = (slot) => `${API}/public/media/${slot}`;
export function reportClientError(kind, message, slot = "") {
  pub.post("/client-error", { kind, message: String(message).slice(0, 300), slot, page: window.location.hostname.slice(0, 60) }).catch(() => {});
}

// Anonymous discovery counter: each event is sent at most once per browser visit (tab session). Nothing else is sent.
export function countOnce(event) {
  const k = `seen_${event}`;
  try { if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, "1"); } catch { /* private mode: count anyway */ }
  pub.post("/beacon", { event }).catch(() => {});
}

export const opsApi = (slug) => axios.create({ baseURL: `${API}/ops/${slug}`, withCredentials: true });

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export function getCookie(name) {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function setCookie(name, value, days = 30) {
  const exp = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax; Secure`;
}
